import '../../App.css';
import Stack from '@mui/material/Stack';
import { jsonToTable } from '../../utils/StringUtils';
import Box from '@mui/material/Box';

const RawBoard3Tab = (props) => {
    const { packet } = props;
    
    return (
        <>
            <Stack direction='row' spacing={1}>
                {(packet.board3 !== null) && (
                    <>
                        <Box key="Header">
                            Header
                            {jsonToTable(packet.board3.header)}
                        </Box>
                        <Box key="Analog100V">
                            Analog100V
                            {jsonToTable(packet.board3.analog100V)}
                        </Box>
                        <Box key="Digital60V">
                            Digital60V
                            {jsonToTable(packet.board3.digital60V)}
                        </Box>
                        <Box key="Digital24V">
                            Digital24V
                            {jsonToTable(packet.board3.digital24V)}
                        </Box>
                        <Box key="DryContact">
                            DryContact
                            {jsonToTable(packet.board3.dryContact)}
                        </Box>
                        <Box key="Counter">
                            Counter
                            {jsonToTable(packet.board3.counter)}
                        </Box>
                        <Box key="Extra3">
                            Extra3
                            {jsonToTable(packet.board3.extra3)}
                        </Box>
                    </>
                )}
            </Stack>
        </>
    );
};

export default RawBoard3Tab;